/* Angular */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

/* XPO */
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import {
  XPO_AUTH_CONFIG,
  xpoAccessTokenKey,
  XpoAuthConfig,
  xpoAuthConfigManagerConfiguration,
} from '@xpo-ltl/ngx-auth';
import { XpoLtlShellMenuComponent } from '@xpo-ltl/ngx-ops-core';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';

/* Components and Env */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { ApiResponseInterceptor } from './shared/api-response/api-response.interceptor';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { CostAllocationApiService } from '@xpo-ltl/sdk-costallocation';
import { HumanResourceApiService } from '@xpo-ltl-2.0/sdk-humanresource';
import { AlertService } from './module-executor/services/alert/alert.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    XpoSnackBarModule,
    BrowserAnimationsModule,
    HttpClientModule,
    XpoLtlShellMenuComponent,
    XpoShellModule,
  ],
  providers: [
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration({
        firebaseOptions: environment.firebase,
        configFileUrl: '../assets/config.json',
      })
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true,
    },
    AlertService,
    CostAllocationApiService,
    HumanResourceApiService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
